import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getEventDetails(payload) {
  const criteria = `{"filters":[ "*", "event.description", "event.eventType.description", "event.icon","route.id","route.key","route.date","route.organization.*", "route.plannedStart", "route.projectedStart", "route.actualStart",
      "route.plannedDeparture", "route.projectedDeparture", "route.actualDeparture",
      "route.plannedArrival", "route.projectedArrival", "route.actualArrival",
      "route.plannedComplete", "route.projectedComplete", "route.actualComplete", "hoursOfService.*", "driver.*",
      "equipment.id", "equipment.key","equipment.description", "equipment.equipmentType.description", "equipment.organization.id", "equipment.organization.description",
      "route.driverAssignments.id","route.driverAssignments.driver.id","route.driverAssignments.driver.*",
      "stop.id","stop.*", "stop.key","stop.location.*", "stop.location.locationOverrideTimeWindows.*", "stop.location.timeWindowType.*",
      "stop.plannedArrival", "stop.projectedArrival", "stop.plannedService",
      "stop.projectedService", "stop.plannedDeparture", "stop.projectedDeparture", "stop.plannedSize1",
      "stop.plannedSize2", "stop.plannedSize3",
      "stop.stopType.id", "stop.stopType.key","stop.stopType.*",
      "order.id", "order.number", "order.plannedSize1", "order.plannedSize2", "order.plannedSize3",
      "lineItem.id", "lineItem.lineItemID", "lineItem.plannedSize1", "lineItem.plannedSize2", "lineItem.plannedSize3",
      "openedBy.id", "openedBy.name", "closed", "solvedBy.id", "solvedBy.name", "eventLogDrivers.*","eventLogDrivers.driver.key", "eventLogDrivers.driver.name", "eventLogDrivers.driver.organization.*"
      ], "including":["coordinate"]}`;

  const url = `/EventLog/FindAndLock?criteria=${encodeURI(criteria)}`;

  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    return Promise.reject(response);
  }

  return response;
}

export function useEventDetails(payload) {
  return useQuery({
    queryKey: ['event-details'],
    queryFn: () => getEventDetails(payload),
    staleTime: 5 * 60 * 1000, // 5 min
    retry: 2,
    enabled: false
  });
}
